import React from "react";
import { motion } from "framer-motion";

// Line-by-line masked reveal for headings (container-driven, robust whileInView)
export const MaskReveal = ({ lines = [], className = "", delay = 0, now = false }) => {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12, delayChildren: delay } },
  };
  const line = {
    hidden: { y: "110%" },
    show: { y: "0%", transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
  };
  const trigger = now
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true, amount: 0.2 } };
  return (
    <motion.span className={className} variants={container} initial="hidden" {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className="block" variants={line}>
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

// Generic fade-up on scroll into view
export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
    {...rest}
  >
    {children}
  </motion.div>
);
